import { IconButton } from "@mui/material";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { ContactsDialog } from "../../page/PersonRepositoryPage/ContactsDialog";
import EditIcon from "@mui/icons-material/Edit";

export function ContactEditButton({ personId, rowData, color = "primary" }) {
    const { openDialog: openContactsDialog } = useDialogBetter();

    return (
        <IconButton
            color={color}
            onClick={() => {
                openContactsDialog({
                    Component: ContactsDialog,
                    componentProps: {
                        personId: personId,
                        isEdit: true,
                        rowData: rowData,
                    },
                });
            }}
        >
            <EditIcon />
        </IconButton>
    );
}